import styled from 'styled-components'

export const BoxTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid rgba(26, 54, 126, 0.125);
  padding: 0 0 10px 10px;
`

export const LblTitle = styled.div`
  white-space: nowrap;

  font-weight: 400;
  font-size: 1.1rem;

  color: rgba(0, 0, 0, 0.7);
`

export const MainTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: -22px;
`
export const ValueTotal = styled.div`
  font-size: 1.8rem;
  font-weight: 600;
  color: #3f6ad8;
`
export const LblTotal = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  opacity: 0.6;
  color: #495057;
`
